import React, { forwardRef, useState } from "react";
import Typography from "@material-ui/core/Typography";
import { Box,Grid } from "@material-ui/core";

// import "./EmployeeTImeSheet.css";
 
const ComponentToPrintRetro = React.forwardRef((props, ref) => {
  const {
    dataTable,
    reportHeader,
    TimeSheetummary
  } = props;
 
 
  

  

  
  return (
    <div ref={ref}>
      <style type="text/css" media="print">
        {` @page {size :"landscape"} `}
      </style> 
      {reportHeader}
      {dataTable}
      {TimeSheetummary}
      <div className="d-flex"> 
      </div>
      <div style={{width:"100%"}}> 
      </div>
   
    
    </div>
  );
});

export default ComponentToPrintRetro;
